import { useState } from "react";
import { Box } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import AnalyticsMobileFilterBar from "./AnalyticsMobileFilterBar";
import AnalyticsMobileTabs, { AnalyticsMobileView } from "./AnalyticsMobileTabs";
import AnalyticsMobileHighLevel from "./AnalyticsMobileHighLevel";
import AnalyticsMobileBreakdown from "./AnalyticsMobileBreakdown";
import AnalyticsMobileSkeleton from "./AnalyticsMobileSkeleton";

interface AnalyticsMobileProps {
  data: LeadsManagementData;
}

// Mobile-only rebuild of the Analytics tab — same date-range filter pattern
// as the Leads tab (LeadsMobileDateRangeDrawer) plus a brand picker in
// place of free-text search, a High Level/Breakdown segmented toggle (no
// desktop equivalent — the desktop tab shows both sections stacked at
// once), and the 3 High Level stat cards / 4 Breakdown charts rebuilt as
// single-column mobile cards instead of reusing the desktop's grid layout.
export default function AnalyticsMobile({ data }: AnalyticsMobileProps) {
  const [view, setView] = useState<AnalyticsMobileView>("highLevel");

  return (
    <Box>
      <AnalyticsMobileTabs view={view} onChange={setView} disabled={data.isLoading} />
      <AnalyticsMobileFilterBar data={data} />

      {data.isLoading ? (
        <AnalyticsMobileSkeleton cardCount={view === "highLevel" ? 2 : 4} bodyHeight={view === "highLevel" ? 120 : 190} />
      ) : view === "highLevel" ? (
        <AnalyticsMobileHighLevel data={data} />
      ) : (
        <AnalyticsMobileBreakdown data={data} />
      )}
    </Box>
  );
}
